module.exports = __webpack_public_path__ + "static/media/Rebecca@3x.f94934e8.png";